/* News block */
const langCode = document.documentElement.lang;
const lang = langCode.split("-")[0];

const translations = {
    pl: {
        read_more: 'Czytaj więcej',
        load_more: 'Wczytaj kolejne posty',
        load_more_from_newest: 'Wczytaj posty od najnowszego',
        load_more_from_oldest: 'Wczytaj posty od najstarszego',
        loading: 'Wczytywanie',
    },
    en: {
        read_more: 'Read more',
        load_more: 'Load more posts',
        load_more_from_newest: 'Load posts from newest',
        load_more_from_oldest: 'Load posts from oldest',
        loading: 'Loading',
    }
};

const t = translations[lang] || translations.en;

const formatExcerpt = (html) => {
    if (!html) return '';

    const decode = str => {
        const t = document.createElement("textarea");
        t.innerHTML = str;
        return t.value;
    };

    let text = decode(decode(html));

    text = text.replace(/[“”„‟«»]/g, '"');

    text = text.replace(
        /\[a\s+href\s*=\s*"?([^"\]\s]+)"?\](.*?)\[\/a\]/gis,
        (_, href, label) => `<a href="${href}">${label}</a>`
    );

    text = text.replace(/<(?!\/?a\b)[^>]+>/gi, '');

    return text;
};

const extractText = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    let textParts = [];

    // normalny tekst
    const walker = document.createTreeWalker(
        doc.body,
        NodeFilter.SHOW_TEXT,
        null,
        false
    );

    let node;
    while (node = walker.nextNode()) {
        const val = node.nodeValue.trim();
        if (val) textParts.push(val);
    }

    // figcaption (opis obrazka z bloku)
    doc.querySelectorAll("figcaption").forEach(el => {
        const val = el.textContent.trim();
        if (val) textParts.push(val);
    });

    return textParts.join(" ");
};


const htmlElements = (post, image, elements) => {
    const postDate = post.date;
    const options = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'};
    const dateObj = new Date(postDate);
    const dateStr = dateObj.toLocaleDateString(lang === 'pl' ? 'pl-PL' : 'en-US', options);

    return `
        <div class="bsk-tile__image ${elements.filterSepia}">

                ${image ? '<img src="' + image + '" alt="BSK Boxernia">' : '<img src="' + window.location.origin + '/wp-content/themes/boxernia/assets/images/bsk.webp" alt="BSK Boxernia">'}

        </div>
        <div class="bsk-tile__text p-4">
            <${elements.newsTagTitleTile} class="bsk-tile__title-slide">
                ${post.title.rendered}
            </${elements.newsTagTitleTile}>
        
            <p class="bsk-tile__date"><span>${dateStr}</span></p>
        
            ${
            (() => {
                const excerptText = formatExcerpt(post.excerpt?.rendered || '');
                const contentText = extractText(post.content?.rendered || '');
    
                const clean = str => str.replace(/<[^>]*>/g,'').trim();
    
                const description =
                    clean(excerptText).length > 0
                        ? excerptText
                        : contentText;
    
                return `<p class="bsk-tile__description">${description}</p>`;
            })()
            }
        
            <a class="bsk-tile__btn bsk-btn-1 mt-auto mx-auto ajax-link" href="${post.link}">
                ${t.read_more}
            </a>
        </div>
    `;
};

const loadAjax = (type, target, isLoading, page, elements, postsOrder, perPage, callback) => {
    if (!isLoading) {
        isLoading = true;
        target.innerHTML = t.loading + '...';

        if(type === 'load-start-asc') {
            elements.list.innerHTML = '';
        }

        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4 && xhr.status === 200) {
                const data = JSON.parse(xhr.responseText);

                data.forEach(post => {
                    const li = document.createElement('li');
                    li.classList.add('bsk-tile', 'g-col-12', 'g-col-sm-6', 'g-col-md-4');

                    let image = false;
                    const mediaId = post.featured_media;
                    if (mediaId) {
                        const mediaEndpoint = post._links['wp:featuredmedia'][0].href;

                        fetch(mediaEndpoint)
                            .then(response => response.json())
                            .then(data => {
                                const thumbnailUrl = data.source_url;
                                image = thumbnailUrl;
                                li.innerHTML = htmlElements(post, image, elements);
                            })
                            .catch(error => console.error(error));
                    } else {
                        li.innerHTML = htmlElements(post, image, elements);
                    }

                    elements.list.appendChild(li);
                });

                isLoading = false;

                if(callback) callback(data.length);

                if(type === 'load-start-asc') {
                    target.innerHTML = postsOrder === 'asc' ? t.load_more_from_newest : t.load_more_from_oldest;
                } else if(type === 'laod-more') {
                    target.innerHTML = t.load_more;
                }
            }
        };

        const siteId = parseInt(document.body.getAttribute('data-site-id'));
        const langPrefix = (siteId === 2) ? '/en' : '';

        xhr.open('GET', `${window.location.origin}${langPrefix}/wp-json/wp/v2/posts?per_page=${perPage}&order=${postsOrder}&page=${page}`);
        xhr.send();
    }
};

export const blockNewsBlock = () => {
    const bskNewsAll = document.querySelectorAll('.bsk-news');
    if(bskNewsAll.length) {
        bskNewsAll.forEach(bskNews => {
            let page = 2;
            let isLoading = false;
            let postsOrder = bskNews.getAttribute("data-posts-order").toLowerCase();
            const perPage = Number(bskNews.getAttribute("data-posts-per-pages"));
            const totalPosts = Number(bskNews.getAttribute("data-count-posts"));
            let loadedPosts = Number(bskNews.querySelector(".bsk-news__count-posts-show").innerText);

            const btnLoadMore = bskNews.querySelector(".bsk-tile__btn-load-more");
            const elements = {
                list: bskNews.querySelector('.bsk-news__list'),
                filterSepia: bskNews.getAttribute("data-filter-sepia") ? 'filter-sepia' : '',
                newsTagTitleTile: bskNews.getAttribute("data-tag-title-tile") ? bskNews.getAttribute("data-tag-title-tile") : 'h3',
            };

            bskNews.addEventListener('click', function (e) {
                const {target} = e;
                if(target.classList.contains("bsk-tile__btn-load-more")) {
                    loadAjax('laod-more', target, isLoading, page, elements, postsOrder, perPage, (count) => {
                        loadedPosts += count;
                        if(loadedPosts > totalPosts) loadedPosts = totalPosts;
                        bskNews.querySelector(".bsk-news__count-posts-show").innerText = loadedPosts;

                        if(loadedPosts >= totalPosts) {
                            if(btnLoadMore) btnLoadMore.setAttribute("disabled", true);
                        }
                    });
                    page++;
                } else if(target.classList.contains("bsk-tile__btn-load-start")) {
                    postsOrder = postsOrder === 'asc' ? 'desc' : 'asc';
                    loadAjax('load-start-asc', target, isLoading, 1, elements, postsOrder, perPage, (count) => {
                        loadedPosts = count;
                        if(loadedPosts > totalPosts) loadedPosts = totalPosts;
                        bskNews.querySelector(".bsk-news__count-posts-show").innerText = loadedPosts;

                        page = 2;

                        if(loadedPosts >= totalPosts) {
                            if(btnLoadMore) btnLoadMore.setAttribute("disabled", true);
                        } else {
                            if(btnLoadMore) btnLoadMore.removeAttribute("disabled");
                        }
                    });
                }
            });
        });
    }
};
